import React from "react";
import TranslatorService from "../../../services/Translator/TranslatorService";

const ChatHeader = ({
  name,
  projectId,
  projectName,
  descricao,
  toggleDetails,
  showDetails,
  toFirstLetterUpperCase,
}) => {
  return (
    <div className="breadcrumb d-flex align-items-center flex-sh-0">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="/">
              &ensp;
              {projectName}
            </a>
          </li>
          <li className="breadcrumb-item roxo-aira active" aria-current="page">
            {name}
          </li>
        </ol>
        {descricao && (
          <div className="details-header btn-open">
            <button
              className="btn btn-primary bg-success text-white"
              onClick={toggleDetails}
            >
              <TranslatorService path="chatsBreadcrumbs.details" />
            </button>
            {showDetails && (
              <div className="dropdown-content text-muted h6 p-4">
                {Object.keys(descricao).map((key, index) => (
                  <p key={index} className="pt-1">
                    <strong>{key}:</strong> {descricao[key]}
                  </p>
                ))}
              </div>
            )}
          </div>
        )}
      </nav>
    </div>
  );
};

export default ChatHeader;
